<template>
  <div id="func-20">
    <FuncionalidadeHeader
      v-if="funcionalidade.parametros.detalheDeclaracaoTituloNavegacao"
      :titulo="funcionalidade.parametros.detalheDeclaracaoTituloNavegacao"
      :voltar="voltarNavegacao"
    />
    <ul
      class="func-listagens"
      style="padding: 0 20px; margin-top: 10px; max-height: auto;"
    >
      <li
        v-for="(tipo, index) in tipoDeclaracoes"
        :key="index"
        :name="index"
        class="func-20-list"
      >
        <div style="margin-top: 20px">
          <h2 class="func-20-title">{{ tipo.nome }}</h2>
        </div>
        <div class="listagem-status">
          <el-table
            :cell-style="estiloLinha"
            :data="tipo.declaracoes"
            :row-class-name="'status-row'"
            style="width: 100%"
          >
            <el-table-column
              v-for="(column, index) in columns"
              :key="index"
              :align="column.component ? 'right' : ''"
              :label="column.header ? column.header.label : null"
              :sortable="!!(column.header && column.header.sortable)"
            >
              <template slot-scope="scope">
                <div v-if="column.component">
                  <div
                    v-if="defineColunaAcao">
                    <AcoesDeclaracoes
                      :row="scope.row"
                    >
                    </AcoesDeclaracoes>
                  </div>
                  <el-button
                    v-else
                    type="text"
                    :style="estiloLink"
                    @click="downloadRow(scope.row)"
                  >
                    Download
                    <inline-svg style="position: relative; top: 2px;" height="12" :fill="estilo.aplicacao.corPrimariaAplicacao" :src="require('@/assets/icons/icon_mini_download.svg')"></inline-svg>
                  </el-button>
                </div>
                <template
                  v-else-if="!column.component && column.html"
                  :class-name="`item-${column.field}`"
                >
                  <div
                    v-html="column.html(scope.row[column.field])"
                  />
                </template>
                <template
                  v-else
                  :class-name="`item-${column.field}`"
                >
                  {{ scope.row[column.field] || '-' }}
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="tipo.ativaSelecaoPeriodo">
            <ButtonDefault
              border
              :title="tipo.textoSelecaoPeriodo"
              @click="showSelecaoPeriodoDialog(tipo)"
            />
          </div>
        </div>
      </li>
    </ul>

    <DialogDefault
      id="dialog-carencias"
      :open.sync="selecaoPeriodoDialog"
      :title="(tipoDeclaracaoSelecionado || {}).textoSelecaoPeriodo"
      @close="close"
      width="400"
    >
      <div>
        <el-date-picker
          v-model="dataPickerValue"
          type="daterange"
          start-placeholder="Data inicial"
          end-placeholder="Data Final"
          clearable
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
        />

        <ButtonDefault
          border
          title="Aplicar"
          :disabled="!dataPickerValue || dataPickerValue.length === 0"
          @click="gerarSelecaoPeriodo()"
        />
      </div>
    </DialogDefault>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import AcoesDeclaracoes from '@/views/20/AcoesDeclaracoes'
import { downloadBase64, forceDownloadURL } from '@/utils/Download'
import inlineSvg from 'vue-inline-svg'
import ButtonDefault from '@/components/buttons/ButtonDefault.vue'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

export default {
  name: 'Func20Declaracoes',
  components: { DialogDefault, ButtonDefault, FuncionalidadeHeader, inlineSvg, AcoesDeclaracoes },
  data () {
    return {
      columns: [
        { field: 'titulo', html: this.boldTitulo },
        { field: 'subTitulo', html: this.parseSubTitulo },
        { field: 'acoes', component: true }
      ],
      tipoDeclaracoes: [],
      selecaoPeriodoDialog: false,
      tipoDeclaracaoSelecionado: null,
      dataPickerValue: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem']),
    voltarNavegacao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return false
        default:
          return true
      }
    },
    estiloLink () {
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao} !important`
      }
    },
    maxHeight () {
      const height = window.screen.availHeight
      return {
        'max-height': `${height}px`
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.detalheDeclaracaoTituloNavegacao
    },
    estiloTituloNavegacao () {
      return {
        color: this.funcionalidade.parametros.corTituloNavegacao
      }
    },
    estiloIconeNavegacao () {
      return {
        color: this.funcionalidade.parametros.corIconeNavegacao
      }
    },
    estiloVoltarNavegacao () {
      return {
        color: this.funcionalidade.parametros.corVoltarNavegacao
      }
    },
    defineColunaAcao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getList()
    },
    async getList () {
      const lista = await this.apiFuncionalidade.lista({ loading: true })

      if (lista.status) {
        this.tipoDeclaracoes = lista.data.tipoDeclaracoes
      }
    },
    async getDetalhe (payload) {
      const detalhe = await this.apiFuncionalidade.detalhe({
        loading: true,
        payload
      })

      if (detalhe.status) {
        return detalhe.data
      }
    },
    async downloadRow (declaracao) {
      const downloadData = await this.getDetalhe({
        idDeclaracao: declaracao.idDeclaracao
      })
      await this.download(downloadData, declaracao)
    },
    async downloadSelecaoPeriodo (declaracao, dataInicial, dataFinal) {
      const downloadData = await this.getDetalhe({
        idTipoDeclaracao: declaracao.idTipoDeclaracao,
        dataInicial: dataInicial,
        dataFinal: dataFinal
      })
      await this.download(downloadData, declaracao)
    },
    async download (downloadData, declaracao) {
      if (!downloadData) {
        return
      }

      if (downloadData.url) {
        await forceDownloadURL({
          nome: `${Date.now()}.pdf`,
          url: downloadData.url
        })
      } else {
        downloadBase64({
          nome: `${Date.now()}.pdf`,
          base64: downloadData.base64
        })
      }
    },
    parseSubTitulo (text) {
      if (!text) {
        return '-'
      }

      return text.replace(' - ', '<br>')
    },
    boldTitulo (text) {
      return `<b>${text}</b>`
    },
    estiloLinha () {
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}0d !important`,
        'border': 'none !important'
      }
    },
    showSelecaoPeriodoDialog (tipoDeclaracao) {
      this.selecaoPeriodoDialog = true
      this.tipoDeclaracaoSelecionado = tipoDeclaracao
    },
    async gerarSelecaoPeriodo () {
      if (!this.dataPickerValue || this.dataPickerValue.length === 0) {
        return
      }
      await this.downloadSelecaoPeriodo(
        this.tipoDeclaracaoSelecionado,
        this.dataPickerValue[0],
        this.dataPickerValue[1]
      )
      this.close()
    },
    close () {
      this.selecaoPeriodoDialog = false
      this.dataPickerValue = []
      this.tipoDeclaracaoSelecionado = null
    }
  }
}
</script>
